import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import Axios from 'axios'
import VueCookies from 'vue-cookies'
import moment from "moment";
import md5 from "js-md5";
import SearchSelect from './components/SearchSelect'

Vue.use(VueCookies);
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.component('SearchSelect', SearchSelect);
Vue.prototype.$log = console.log.bind(console);

let baseURL;
// baseURL = process.env.NODE_ENV === "production" ? 'https://user.airmy.life/api' : 'http://airmylife.htroy.com/api';
Axios.defaults.baseURL = '/api';
Axios.defaults.withCredentials = true;

Axios.defaults.validateStatus = function validateStatus(status) {
  return status >= 200;
};

Vue.prototype.$axios = Axios;
Vue.prototype.$moment = moment;
Vue.prototype.$md5 = md5;

// 轻量全局 toast（项目未引入 vue-toasted，此处提供兼容实现）
Vue.prototype.$toasted = {
  show(message, options) {
    const opts = options || {};
    const colors = {
      success: '#2eb85c',
      error: '#e55353',
      warning: '#f9b115',
      info: '#3399ff',
      default: '#303c54'
    };
    const bg = colors[opts.type] || colors.default;
    const el = document.createElement('div');
    el.textContent = message;
    el.style.cssText =
      'position:fixed;top:20px;right:20px;z-index:20000;max-width:360px;' +
      'padding:10px 16px;border-radius:4px;color:#fff;font-size:14px;' +
      'box-shadow:0 4px 12px rgba(0,0,0,.18);opacity:0;' +
      'transition:opacity .25s ease;background:' + bg + ';';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.style.opacity = '1'; });
    const duration = typeof opts.duration === 'number' ? opts.duration : 2600;
    setTimeout(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 300);
    }, duration);
  }
};

router.beforeEach((to, from, next) => {
  if (Vue.prototype.$cookies.get('key') === null && (to.fullPath !== '/auth/login' && to.fullPath !== '/auth/register')) {
    next('/auth/login');
  } if (Vue.prototype.$cookies.get('key') !== null && (to.fullPath === '/auth/login' || to.fullPath === '/auth/register')) {
    console.log(Vue.prototype.$cookies.get('key'))
    next('/index');
  } else {
    next();
  }
})

Axios.interceptors.response.use(function (response) {
  if (response.status === 401) {
    router.push(response.data.newLocation);
  }
  if (response.status === 404) {
    router.push('/404');
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});

Vue.filter('dateFormat', function (daraStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if (daraStr < 1000000000000) daraStr *= 1000
  return moment(daraStr).format(pattern)
})

Vue.filter('dateFormatDate', function (daraStr, pattern = 'YYYY-MM-DD') {
  if (daraStr < 1000000000000) daraStr *= 1000
  return moment(daraStr).format(pattern)
})

Vue.filter('percent', function (daraStr) {
  return daraStr.toFixed(2)+"%"
})

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
